export default __webpack_public_path__ + "static/media/copyLineItems.12177181.png";